import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { GitlabClient } from '../httpClients/GitlabClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useLoginGitlabMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.login');

  return useMutation({
    mutationKey: [MUTATION_KEYS.LOGIN_GITLAB],
    mutationFn: async () => {
      return await GitlabClient.login();
    },
    onError: (err: any) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
